import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-textarea" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}

import { ref, watchEffect } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-textarea',
  props: {
    width: { default: "100%" },
    height: {},
    radius: { default: "6px" },
    background: { default: "#fff" },
    value: {},
    mask: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "ee82247a": (_ctx.width),
  "f3b4a796": (_ctx.radius),
  "v0bf10b51": (_ctx.background)
}))

const props = __props;

const emit = __emit;

const internalValue = ref<string | number | null>(null);

function update(event: any) {
  let value = event.target.value;
  if (props.mask) value = props.mask(value);

  internalValue.value = value;
  emit("update:modelValue", internalValue.value);
}

watchEffect(() => {
  if (props.value !== undefined)
    internalValue.value = props.value?.replace(/\\n/g, "\n");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      _withDirectives(_createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
        autocomplete: "off",
        onInput: update
      }), null, 16), [
        [_vModelText, internalValue.value]
      ])
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})